import React from "react";
// import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import { getAccountInvoices } from "../../selectors/currentAccountSelector.ts";
// import ProfilePaymentHistory from "../helpers/ProfilePaymentHistory.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import styles from "../../styles/BreadcrumbWrapper.module.scss";
import { withRouter } from "react-router-dom";

const BreadcrumbWrapper = (props) => {
  // let { url } = useRouteMatch();
  const {
    children,
    location: { pathname },
  } = props;

  const pathnames = pathname.split("/").filter((x) => x);

  const lastPage = pathnames[pathnames.length - 1];
  const hideFromPages = [
    "profile",
    "support",
    "ads",
    "earnings",
    "settings",
    "games",
  ];

  if (hideFromPages.some((route) => route === lastPage)) {
    return children;
  }

  function renderBreadcrumbs() {
    return pathnames.map((name, index) => {
      const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
      const isLast = index === pathnames.length - 1;
      //console.log("routeTo", routeTo);
      //console.log("isLast", isLast);

      return isLast ? (
        <div key={index}>
          {index >= 1 && (
            <FontAwesomeIcon
              className={styles.checkIcon}
              icon={faChevronRight}
            />
          )}
          <span to={routeTo} className={styles.selected}>
            {name}
          </span>
        </div>
      ) : (
        <div key={index}>
          {index >= 1 && (
            <FontAwesomeIcon
              className={styles.checkIcon}
              icon={faChevronRight}
            />
          )}

          <Link className={styles.active} to={routeTo}>
            {name}
          </Link>
        </div>
      );
    });
  }

  return (
    <div className={styles.breadcrumbWrapper}>
      <div className={styles.crumbs}>{renderBreadcrumbs()}</div>
      <div className={styles.crumbContent}>{children}</div>
    </div>
  );
};

export default withRouter(BreadcrumbWrapper);
